import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Table,
  Header,
  Box,
  SpaceBetween,
  Container,
  ExpandableSection,
  FormField,
  Input,
  Button,
  Form,
  Grid,
  Alert,
  ContentLayout,
  Select,
  DatePicker,
  Flashbar,
  Spinner,
  Badge,
  Checkbox,
  TextContent,
  Modal,
  Textarea,
  FileUpload,
} from "@cloudscape-design/components";
import { useTranslation } from "react-i18next";
import {
  FaBatteryFull,
  FaPerson,
  FaPlane,
  FaStar,
} from "react-icons/fa6";
import BaseLayout from "./BaseLayout";
import moment from "moment/moment";
import API from "../api";

const data = {
  euro_ex_uk: {
    plan_1: "Europe without UK",
    plan_2: "Full Level",
    plan_3: "Business Class",
    plan_4: "5 Star Hotel",
    plan_5: "1",
    plan_6: "USD 2,000,000",
    plan_7: "USD 30,000",
    plan_8: "USD 350",
    plan_9: "USD 15,000",
    plan_10: "USD 350",
    plan_11: "USD 10,000",
    plan_12: "USD 350",
    plan_13: "USD 20,000",
  },

  ww_ex_usa: {
    plan_1: "World without USA",
    plan_2: "Full Level",
    plan_3: "Business Class",
    plan_4: "5 Star Hotel",
    plan_5: "1",
    plan_6: "USD 2,000,000",
    plan_7: "USD 30,000",
    plan_8: "USD 350",
    plan_9: "USD 15,000",
    plan_10: "USD 350",
    plan_11: "USD 10,000",
    plan_12: "USD 350",
    plan_13: "USD 20,000",
  },
  ww_in_usa: {
    plan_1: "World including USA",
    plan_2: "Full Level",
    plan_3: "First Class",
    plan_4: "5 Star Hotel",
    plan_5: "1",
    plan_6: "USD 2,000,000",
    plan_7: "USD 100,000",
    plan_8: "USD 500",
    plan_9: "USD 25,000",
    plan_10: "USD 500",
    plan_11: "USD 20,000",
    plan_12: "USD 500",
    plan_13: "USD 50,000",
  },
};

const QuotationRequest = () => {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const defaultPlanValue = searchParams.get("plan");
  const defaultPlanOption = defaultPlanValue
    ? {
        label: { euro_ex_uk: t("europe_plan"), ww_ex_usa: t("world_plan_1"), ww_in_usa: t("world_plan_2") }[defaultPlanValue],
        value: defaultPlanValue,
      }
    : null;

  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [contactStart, setContactStart] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [contactPersonInsured, setContactPersonInsured] = useState("");

  const [personsData, setPersonsData] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [isQuestionsLoaded, setIsQuestionsLoaded] = useState(false);

  const [flashItems, setFlashItems] = useState([]);
  const [filteringText, setFilteringText] = useState("");

  const [filteredOccupation, setFilteredOccupation] = useState([]);

  const [responseLoaded, setResponseLoaded] = useState(true);

  const [paymentType, setPaymentType] = useState(null);

  const [declarations, setDeclarations] = useState({
    truthfulness: false,
    quotationAcknowledgment: false,
    medicalDisclosure: false,
    readIncExc: false,
  });

  // Add this function to handle checkbox changes:
  const handleDeclarationChange = (key, checked) => {
    setDeclarations((prev) => ({
      ...prev,
      [key]: checked,
    }));
  };

  // Check if all declarations are checked:
  const allDeclarationsChecked = Object.values(declarations).every(
    (checked) => checked
  );

  const [visible, setVisible] = useState(false);
  const [hasReadToEnd, setHasReadToEnd] = useState(false);
  const scrollableRef = useRef(null);

  const [tcVisible, setTcVisible] = useState(false);
  const [tcHasReadToEnd, setTcHasReadToEnd] = useState(false);
  const tcScrollableRef = useRef(null);

  const handleScroll = () => {
    if (scrollableRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollableRef.current;
      const scrolledToBottom = scrollTop + clientHeight >= scrollHeight - 10; // 10px threshold

      if (scrolledToBottom && !hasReadToEnd) {
        setHasReadToEnd(true);
      }
    }
  };

  const handleModalOpen = () => {
    setVisible(true);
    setHasReadToEnd(false); // Reset when opening modal
  };

  const handleModalClose = () => {
    if (hasReadToEnd) {
      setVisible(false);
    }
  };

  const handleTcModalClose = () => {
    if (tcHasReadToEnd) {
      setTcVisible(false);
    }
  };

  const handleTcScroll = () => {
    if (tcScrollableRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        tcScrollableRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setTcHasReadToEnd(true);
      }
    }
  };

  const getSchedule = () => {
    setResponseLoaded(false);
    var jsonData = [];
    console.log(personsData);
    for (var i = 0; i < personsData.length; i++) {
      jsonData.push({
        year: moment().format("YYYY"),
        policyholder_name: personsData[i].name,
        address: personsData[i].address,
        policy_number: `9005/${moment().format("YY")}/01/${personsData[i].id}`,
        contact_number: personsData[i].contact_number,
        email: personsData[i].contact_email,
        effective_date: moment(contactStart, ["YYYY-MM-DD", "YYYY/MM/DD"], true).isValid()
          ? moment(contactStart, ["YYYY-MM-DD", "YYYY/MM/DD"]).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        date_of_birth: personsData[i].date_of_birth,
        age: moment().diff(
          moment(personsData[i].date_of_birth, "YYYY-MM-DD"),
          "year"
        ),
        renewal_date: moment(contactStart, ["YYYY-MM-DD", "YYYY/MM/DD"], true).isValid()
          ? moment(contactStart, ["YYYY-MM-DD", "YYYY/MM/DD"]).add(365, "days").format("YYYY-MM-DD")
          : moment().add(365, "days").format("YYYY-MM-DD"),
        plan_1: data[personsData[i].plan.value].plan_1,
        plan_2: data[personsData[i].plan.value].plan_2,
        plan_3: data[personsData[i].plan.value].plan_3,
        plan_4: data[personsData[i].plan.value].plan_4,
        plan_5: data[personsData[i].plan.value].plan_5,
        plan_6: data[personsData[i].plan.value].plan_6,
        plan_7: data[personsData[i].plan.value].plan_7,
        plan_8: data[personsData[i].plan.value].plan_8,
        plan_9: data[personsData[i].plan.value].plan_9,
        plan_10: data[personsData[i].plan.value].plan_10,
        plan_11: data[personsData[i].plan.value].plan_11,
        plan_12: data[personsData[i].plan.value].plan_12,
        plan_13: data[personsData[i].plan.value].plan_13,
        country_of_ceding_company: "Kuwait",
        name_of_local_regulator: "IRU",
        country: "Kuwait",
        nationality: personsData[i].nationality_id ? personsData[i].nationality_id.label : '',
        present_occupation: personsData[i].present_occupation ? personsData[i].present_occupation.value : '',
        gender: personsData[i].gender ? personsData[i].gender.value : '',
        height: personsData[i].height,
        weight: personsData[i].weight,
        gain_loss_weight: personsData[i].gain_loss_weight,
        national_id: personsData[i].national_id,
        passport: personsData[i].passport_number,
        personal_physician: personsData[i].personal_physician,
        civil_id_file: personsData[i].civil_id_file_path || "",
        passport_file: personsData[i].passport_file_path || ""
      });
    }

    console.log(jsonData);

    API.post(`/create`, { raw: personsData, contact: {contactName: contactName, contactEmail: contactEmail, contactNumber: contactNumber, contactStart: contactStart, companyName: companyName }, persons: jsonData, payment_type: paymentType?.value })
      .then((response) => {
        if (response.data.operation === true) {
          // setPeriodStart();
          console.log(response.data.data.links);
          setFlashItems([]);
          createFlashbarItem(
            t("flash_created_policy"),
            "success",
            <span>
              {t("flash_policy_numbers")} {response.data.data.polnos.join(", ")}
            </span>
          );
          for (var i = 0; i < response.data.data.links.length; i++) {
            createFlashbarItem(
              t("flash_download_policy"),
              "success",
              <span>
                <a target="_blank" href={response.data.data.links[i]}>
                  {response.data.data.polnos[i]}
                </a>
              </span>
            );
          }
        } else {
          createFlashbarItem(
            t("flash_error_create"),
            "error",
            <span>{response.data.message}</span>
          );
        }
      })
      .catch((error) => {
        console.log(error);
        createFlashbarItem(
          t("flash_error_server"),
          "error",
          <span>{error.message}</span>
        );
      })
      .finally(() => {
        setResponseLoaded(true);
        handleModalClose();
        document.documentElement.scrollTo(0, 0, "smooth");
      });
  };

  useEffect(() => {
    const scrollElement = scrollableRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => scrollElement.removeEventListener("scroll", handleScroll);
    }
  }, [visible]);

  const handleLoadItems = ({ detail }) => {
    const { filteringText } = detail;

    setFilteringText(filteringText);

    // Filter the nationality list
    setTimeout(() => {
      if (filteringText) {
        const filtered = occupationOptions.filter((occupation) =>
          occupation.label.toLowerCase().includes(filteringText.toLowerCase())
        );
        if (filtered.length === 0) {
          setFilteredOccupation([{ label: t("occ_other"), value: 0 }]);
        } else {
          setFilteredOccupation(filtered);
        }
      } else {
        // Show all options when no filter text
        setFilteredOccupation(occupationOptions);
      }
    }, 100);
  };

  const dismissItem = (itemId) => {
    setFlashItems((prevItems) =>
      prevItems.filter((item) => item.id !== itemId)
    );
  };

  const createFlashbarItem = (
    header,
    type = "info",
    content,
    dismissible = true
  ) => {
    flashItems.forEach((i) => dismissItem(i.id));
    const id = `message_${Date.now()}_${Math.random()
      .toString(36)
      .substring(2, 11)}`;

    const newItem = {
      header,
      type,
      content,
      dismissible,
      dismissLabel: t("dismiss_message"),
      onDismiss: () => dismissItem(id),
      id,
    };

    setFlashItems((prevItems) => [...prevItems, newItem]);
    return id;
  };

  const getQuestions = () => {
    setIsQuestionsLoaded(false);
    API.get("/question/get")
      .then((response) => {
        response = response.data;
        if (response.operation) {
          setQuestions(response.data);
        } else {
          createFlashbarItem(
            t("flash_error_questionnaire"),
            "error",
            <>{t("flash_contact_support")}</>
          );
        }
      })
      .catch((error) => {
        console.error(error);
        createFlashbarItem(
          t("flash_error_questionnaire"),
          "error",
          <>{t("flash_contact_support")}</>
        );
      })
      .finally(() => {
        setIsQuestionsLoaded(true);
      });
  };
  const handlePersonCountChange = (newCount) => {
    const count = newCount;

    const questionnaireResponses = {};
    questions.forEach((q) => {
      questionnaireResponses[q.stc_cq_id] = {
        answer: "no", // 'yes' or 'no'
        remarks: "",
      };
    });

    const newPersonsData = [];
    for (let i = 0; i < count; i++) {
      newPersonsData.push({
        id: i + 1,
        name: personsData[i]?.name || (i === 0 ? contactName : ""),
        date_of_birth: personsData[i]?.date_of_birth || "",
        present_occupation: personsData[i]?.present_occupation || "",
        height: personsData[i]?.height || "",
        weight: personsData[i]?.weight || "",
        gain_loss_weight: personsData[i]?.gain_loss_weight || "",
        plan: personsData[i]?.plan || defaultPlanOption || {},
        personal_physician: personsData[i]?.personal_physician || "",
        eligible_plans: personsData[i]?.eligible_plans || "",
        quoted_price: personsData[i]?.quoted_price || "",
        age: personsData[i]?.age || "",
        contact_email: personsData[i]?.contact_email || (i === 0 ? contactEmail.toLowerCase() : ""),
        contact_number: personsData[i]?.contact_number || (i === 0 ? contactNumber : ""),
        questionnaire_responses:
          personsData[i]?.questionnaire_responses || questionnaireResponses,
      });
    }
    setPersonsData(newPersonsData);
  };

  const updatePersonData = (index, field, value) => {
    const updatedPersons = [...personsData];
    updatedPersons[index][field] = value;

    setPersonsData(updatedPersons);

    console.log(updatedPersons);
  };

  const updateQuestionnaireResponse = (
    personIndex,
    questionId,
    field,
    value
  ) => {
    // const updatedPersons = [...personsData];
    // if (!updatedPersons[personIndex].questionnaire_responses) {
    //   updatedPersons[personIndex].questionnaire_responses = {};
    // }
    // if (!updatedPersons[personIndex].questionnaire_responses[questionId]) {
    //   updatedPersons[personIndex].questionnaire_responses[questionId] = {
    //     answer: null,
    //     remarks: ''
    //   };
    // }
    // updatedPersons[personIndex].questionnaire_responses[questionId][field] = value;
    // setPersonsData(updatedPersons);
    setPersonsData((prev) => {
      const updated = [...prev]; // create new array only
      const person = { ...updated[personIndex] };

      const responses = { ...(person.questionnaire_responses || {}) };
      const response = {
        ...(responses[questionId] || { answer: null, remarks: "" }),
      };

      response[field] = value;
      responses[questionId] = response;
      person.questionnaire_responses = responses;

      updated[personIndex] = person;
      return updated;
    });
  };

  const QuestionnaireTable = ({ person, personIndex }) => {
    const tableItems = React.useMemo(() => {
      const isArabic = i18n.language === "ar";
      return questions.map((question) => ({
        id: question.stc_cq_id,
        question: isArabic && question.stc_cq_question_ar ? question.stc_cq_question_ar : question.stc_cq_question,
        required: question.stc_cq_is_required,
        answer:
          person.questionnaire_responses?.[question.stc_cq_id]?.answer ?? "no",
        remarks:
          person.questionnaire_responses?.[question.stc_cq_id]?.remarks ?? "",
      }));
    }, [questions, person.questionnaire_responses, i18n.language]);

    const columnDefinitions = useMemo(
      () => [
        {
          id: "question",
          header: t("question_header"),
          cell: (item) => (
            <TextContent wrapLines fontSize="body-s" color="text-body-default">
              {item.question}
              {item.required === "Y" && (
                <span style={{ color: "red" }}> *</span>
              )}
            </TextContent>
          ),
          width: 400,
          wrapLines: true,
        },
        {
          id: "yes",
          header: t("yes"),
          cell: (item) => (
            <Box textAlign="center">
              <input
                type="radio"
                name={`person_${personIndex}_question_${item.id}`}
                value="yes"
                checked={item.answer === "yes"}
                onChange={() =>
                  updateQuestionnaireResponse(
                    personIndex,
                    item.id,
                    "answer",
                    "yes"
                  )
                }
              />
            </Box>
          ),
          width: "60px",
          minWidth: 60,
        },
        {
          id: "no",
          header: t("no"),
          cell: (item) => (
            <Box textAlign="center">
              <input
                type="radio"
                name={`person_${personIndex}_question_${item.id}`}
                value="no"
                checked={item.answer === "no"}
                onChange={() =>
                  updateQuestionnaireResponse(
                    personIndex,
                    item.id,
                    "answer",
                    "no"
                  )
                }
              />
            </Box>
          ),
          width: "60px",
          minWidth: 60,
        },
        {
          id: "remarks",
          header: t("additional_remarks"),
          cell: (item) => (
            <Textarea
              value={item.remarks}
              onChange={({ detail }) =>
                updateQuestionnaireResponse(
                  personIndex,
                  item.id,
                  "remarks",
                  detail.value
                )
              }
              placeholder={t("placeholder_remarks")}
              size="small"
            />
          ),
          width: "250px",
          minWidth: 200,
        },
      ],
      [personIndex, updateQuestionnaireResponse]
    );

    return (
      <Table
        columnDefinitions={columnDefinitions}
        items={tableItems}
        variant="borderless"
        contentDensity="compact"
        stripedRows={true}
        resizableColumns
        hasDynamicContent={true}
        header={
          <Header
            variant="h4"
            description={t("questionnaire_desc")}
          >
            {t("health_questionnaire")}
          </Header>
        }
      />
    );
  };


  const [isNationalityLoaded, setIsNationalityLoaded] = useState(false);
  const [nationalityOptions, setNationalityOptions] = useState([]);

  const getNationality = () => {
    setIsNationalityLoaded(false);
    setNationalityOptions([]);
    API.get("/nationality/get")
      .then((response) => {
        response = response.data;
        if (response.operation) {
          const filtered = response.data.filter(
            (opt) => opt.label?.toLowerCase() !== "rest of the world"
          );
          filtered.push({ label: "Others Nations", value: "others_nations" });
          setNationalityOptions(filtered);
        } else {
          createFlashbarItem(
            t("flash_error_nationalities"),
            "error",
            <>{t("flash_contact_support")}</>
          );
        }
      })
      .catch((error) => {
        console.error(error);
        createFlashbarItem(
          t("flash_error_nationalities"),
          "error",
          <>{t("flash_contact_support")}</>
        );
      })
      .finally(() => {
        setIsNationalityLoaded(true);
      });
  };

  const tarrifs = [
    {
      min: 0,
      max: 17,
      plans: {
        euro_ex_uk: 208.86,
        ww_ex_usa: 294.98,
        ww_in_usa: 1482.54,
      },
    },
    {
      min: 18,
      max: 24,
      plans: {
        euro_ex_uk: 246.92,
        ww_ex_usa: 348.73,
        ww_in_usa: 1752.67,
      },
    },
    {
      min: 25,
      max: 29,
      plans: {
        euro_ex_uk: 257.21,
        ww_ex_usa: 363.26,
        ww_in_usa: 1825.68,
      },
    },
    {
      min: 30,
      max: 34,
      plans: {
        euro_ex_uk: 284.54,
        ww_ex_usa: 401.86,
        ww_in_usa: 2019.72,
      },
    },
    {
      min: 35,
      max: 39,
      plans: {
        euro_ex_uk: 314.79,
        ww_ex_usa: 444.58,
        ww_in_usa: 2234.42,
      },
    },
    {
      min: 40,
      max: 44,
      plans: {
        euro_ex_uk: 349.22,
        ww_ex_usa: 493.21,
        ww_in_usa: 2478.82,
      },
    },
    {
      min: 45,
      max: 49,
      plans: {
        euro_ex_uk: 394.1,
        ww_ex_usa: 556.58,
        ww_in_usa: 2797.32,
      },
    },
    {
      min: 50,
      max: 54,
      plans: {
        euro_ex_uk: 452.55,
        ww_ex_usa: 639.14,
        ww_in_usa: 3212.27,
      },
    },
    {
      min: 55,
      max: 59,
      plans: {
        euro_ex_uk: 529.9,
        ww_ex_usa: 748.39,
        ww_in_usa: 3761.31,
      },
    },
    {
      min: 60,
      max: 64,
      plans: {
        euro_ex_uk: 635.68,
        ww_ex_usa: 897.77,
        ww_in_usa: 4512.13,
      },
    },
    {
      min: 65,
      max: 69,
      plans: {
        euro_ex_uk: 889.95,
        ww_ex_usa: 1256.88,
        ww_in_usa: 6316.95,
      },
    },
    {
      min: 70,
      max: 74,
      plans: {
        euro_ex_uk: 1329.63,
        ww_ex_usa: 1877.83,
        ww_in_usa: 9437.82,
      },
    },
  ];

  function getPlansByDOB(dob) {
    const age = moment().diff(moment(dob, "YYYY-MM-DD"), "years");

    const matchingTariff = tarrifs.find((t) => age >= t.min && age <= t.max);

    if (matchingTariff) {
      return {
        age,
        plans: matchingTariff.plans,
      };
    } else {
      return {
        age,
        plans: [],
      };
    }
  }

  const planOptions = [
    { label: t("europe_plan"), value: "euro_ex_uk" },
    { label: t("world_plan_1"), value: "ww_ex_usa" },
    { label: t("world_plan_2"), value: "ww_in_usa" },
  ];

  const genderOptions = [
    { label: t("gender_male"), value: "male" },
    { label: t("gender_female"), value: "female" },
    { label: t("gender_other"), value: "other" },
  ];

  const occupationOptions = [
    { label: t("occ_accountant"), value: "Accountant" },
    { label: t("occ_actor"), value: "Actor" },
    { label: t("occ_admin"), value: "Administrative Assistant" },
    { label: t("occ_architect"), value: "Architect" },
    { label: t("occ_artist"), value: "Artist" },
    { label: t("occ_attorney"), value: "Attorney/Lawyer" },
    { label: t("occ_banker"), value: "Banker" },
    { label: t("occ_bartender"), value: "Bartender" },
    { label: t("occ_carpenter"), value: "Carpenter" },
    { label: t("occ_chef"), value: "Chef/Cook" },
    { label: t("occ_consultant"), value: "Consultant" },
    { label: t("occ_customer_service"), value: "Customer Service Representative" },
    { label: t("occ_data_analyst"), value: "Data Analyst" },
    { label: t("occ_dentist"), value: "Dentist" },
    { label: t("occ_doctor"), value: "Doctor/Physician" },
    { label: t("occ_driver"), value: "Driver" },
    { label: t("occ_electrician"), value: "Electrician" },
    { label: t("occ_engineer"), value: "Engineer" },
    { label: t("occ_entrepreneur"), value: "Entrepreneur" },
    { label: t("occ_farmer"), value: "Farmer" },
    { label: t("occ_firefighter"), value: "Firefighter" },
    { label: t("occ_graphic_designer"), value: "Graphic Designer" },
    { label: t("occ_hairdresser"), value: "Hairdresser/Stylist" },
    { label: t("occ_hr"), value: "Human Resources" },
    { label: t("occ_insurance_agent"), value: "Insurance Agent" },
    { label: t("occ_it"), value: "IT Specialist" },
    { label: t("occ_janitor"), value: "Janitor/Cleaner" },
    { label: t("occ_journalist"), value: "Journalist" },
    { label: t("occ_manager"), value: "Manager" },
    { label: t("occ_marketing"), value: "Marketing Specialist" },
    { label: t("occ_mechanic"), value: "Mechanic" },
    { label: t("occ_musician"), value: "Musician" },
    { label: t("occ_nurse"), value: "Nurse" },
    { label: t("occ_pharmacist"), value: "Pharmacist" },
    { label: t("occ_photographer"), value: "Photographer" },
    { label: t("occ_plumber"), value: "Plumber" },
    { label: t("occ_police"), value: "Police Officer" },
    { label: t("occ_professor"), value: "Professor/Teacher" },
    { label: t("occ_psychologist"), value: "Psychologist" },
    { label: t("occ_real_estate"), value: "Real Estate Agent" },
    { label: t("occ_receptionist"), value: "Receptionist" },
    { label: t("occ_retail"), value: "Retail Worker" },
    { label: t("occ_sales"), value: "Sales Representative" },
    { label: t("occ_secretary"), value: "Secretary" },
    { label: t("occ_security"), value: "Security Guard" },
    { label: t("occ_social_worker"), value: "Social Worker" },
    { label: t("occ_developer"), value: "Software Developer" },
    { label: t("occ_student"), value: "Student" },
    { label: t("occ_therapist"), value: "Therapist" },
    { label: t("occ_veterinarian"), value: "Veterinarian" },
    { label: t("occ_waiter"), value: "Waiter/Waitress" },
    { label: t("occ_writer"), value: "Writer" },
    { label: t("occ_other"), value: "Other" },
    { label: t("occ_unemployed"), value: "Unemployed" },
    { label: t("occ_retired"), value: "Retired" },
  ];


  const getQuote = () => {};

  const [paymentLoading, setPaymentLoading] = useState(false);
  const [underReviewLoading, setUnderReviewLoading] = useState(false);
  const [underReviewDone, setUnderReviewDone] = useState(false);

  const buildPersonsPayload = () => {
    var jsonData = [];
    for (var i = 0; i < personsData.length; i++) {
      jsonData.push({
        year: moment().format("YYYY"),
        policyholder_name: personsData[i].name,
        address: personsData[i].address,
        policy_number: `9005/${moment().format("YY")}/01/${personsData[i].id}`,
        contact_number: personsData[i].contact_number,
        email: personsData[i].contact_email,
        effective_date: moment(contactStart, ["YYYY-MM-DD", "YYYY/MM/DD"], true).isValid()
          ? moment(contactStart, ["YYYY-MM-DD", "YYYY/MM/DD"]).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        date_of_birth: personsData[i].date_of_birth,
        age: moment().diff(moment(personsData[i].date_of_birth, "YYYY-MM-DD"), "year"),
        renewal_date: moment(contactStart, ["YYYY-MM-DD", "YYYY/MM/DD"], true).isValid()
          ? moment(contactStart, ["YYYY-MM-DD", "YYYY/MM/DD"]).add(365, "days").format("YYYY-MM-DD")
          : moment().add(365, "days").format("YYYY-MM-DD"),
        plan_1: data[personsData[i].plan.value].plan_1,
        plan_2: data[personsData[i].plan.value].plan_2,
        plan_3: data[personsData[i].plan.value].plan_3,
        plan_4: data[personsData[i].plan.value].plan_4,
        plan_5: data[personsData[i].plan.value].plan_5,
        plan_6: data[personsData[i].plan.value].plan_6,
        plan_7: data[personsData[i].plan.value].plan_7,
        plan_8: data[personsData[i].plan.value].plan_8,
        plan_9: data[personsData[i].plan.value].plan_9,
        plan_10: data[personsData[i].plan.value].plan_10,
        plan_11: data[personsData[i].plan.value].plan_11,
        plan_12: data[personsData[i].plan.value].plan_12,
        plan_13: data[personsData[i].plan.value].plan_13,
        country_of_ceding_company: "Kuwait",
        name_of_local_regulator: "IRU",
        country: "Kuwait",
        nationality: personsData[i].nationality_id ? personsData[i].nationality_id.label : '',
        present_occupation: personsData[i].present_occupation ? personsData[i].present_occupation.value : '',
        gender: personsData[i].gender ? personsData[i].gender.value : '',
        height: personsData[i].height,
        weight: personsData[i].weight,
        gain_loss_weight: personsData[i].gain_loss_weight,
        national_id: personsData[i].national_id,
        passport: personsData[i].passport_number,
        personal_physician: personsData[i].personal_physician,
        civil_id_file: personsData[i].civil_id_file_path || "",
        passport_file: personsData[i].passport_file_path || ""
      });
    }
    return jsonData;
  };

  const getYesAnswers = () => {
    const result = [];
    personsData.forEach((person) => {
      const yesQuestions = [];
      questions.forEach((q) => {
        const resp = person.questionnaire_responses?.[q.stc_cq_id];
        if (resp && resp.answer === "yes") {
          yesQuestions.push(q.stc_cq_question);
        }
      });
      if (yesQuestions.length > 0) {
        result.push({ person_name: person.name, questions: yesQuestions });
      }
    });
    return result;
  };

  const submitUnderReview = (yesAnswers) => {
    setUnderReviewLoading(true);
    const personsSummary = personsData.map((p) => ({
      name: p.name,
      dob: p.date_of_birth,
      age: p.age,
      plan: p.plan?.label || "",
      gender: p.gender?.value || "",
      nationality: p.nationality_id?.label || "",
      national_id: p.national_id || "",
      passport_number: p.passport_number || "",
      occupation: p.present_occupation?.value || "",
    }));
    let quote;
    try {
      quote = {
        raw: personsData,
        contact: { contactName, contactEmail, contactNumber, contactStart, companyName },
        persons: buildPersonsPayload(),
        payment_type: paymentType?.value,
      };
    } catch (e) {
      console.error("Could not prepare application for storage", e);
    }

    API.post("/payment/under-review", {
      contact: { contactName, contactEmail, contactNumber, contactStart, companyName },
      yes_answers: yesAnswers,
      persons_summary: personsSummary,
      payment_type: paymentType?.value,
      quote,
    })
      .then((response) => {
        if (response.data.operation) {
          setUnderReviewDone(true);
        } else {
          createFlashbarItem("Failed to submit application. Please try again.", "error", null);
        }
      })
      .catch(() => {
        createFlashbarItem("Failed to submit application. Please try again.", "error", null);
      })
      .finally(() => setUnderReviewLoading(false));
  };

  const initiatePayment = () => {
    setPaymentLoading(true);

    const totalAmount = personsData
      .filter((p) => p.quoted_price)
      .reduce((sum, p) => sum + parseFloat(p.quoted_price), 0)
      .toFixed(3);

    const referenceId = `REF-${Date.now()}`;

    // The whole form is sent with the payment so the backend can store it (STC_CI_REQUEST / PERSON / ...).
    let quote;
    try {
      quote = {
        raw: personsData,
        contact: { contactName, contactEmail, contactNumber, contactStart, companyName },
        persons: buildPersonsPayload(),
        payment_type: paymentType?.value
      };
    } catch (e) {
      console.error("Could not prepare quote for storage", e);
    }

    API.post('/payment/initiate', {
      amount: totalAmount,
      currency: 'KWD',
      customer_name: contactName,
      customer_email: contactEmail,
      customer_phone: contactNumber,
      reference_id: referenceId,
      frontend_url: window.location.origin,
      quote
    })
      .then((response) => {
        if (response.data.operation === true) {
          const checkoutUrl = response.data.data.payment_link;
          // Pre-build the full create payload (same as getSchedule)
          const personsPayload = buildPersonsPayload();
          const createPayload = {
            raw: personsData,
            contact: { contactName, contactEmail, contactNumber, contactStart, companyName },
            persons: personsPayload,
            payment_type: paymentType?.value
          };
          // Store everything needed for post-payment policy creation
          sessionStorage.setItem('ci_payment_form', JSON.stringify({
            order_id: response.data.data.order_id,
            request_id: response.data.data.request_id,
            create_payload: createPayload,
            amount: totalAmount,
            reference_id: referenceId
          }));
          window.location.href = checkoutUrl;
        } else {
          createFlashbarItem(
            t("flash_payment_error"),
            "error",
            <span>{response.data.message}</span>
          );
        }
      })
      .catch((error) => {
        console.error(error);
        createFlashbarItem(
          t("flash_payment_error"),
          "error",
          <span>{error.response?.data?.message || error.message}</span>
        );
      })
      .finally(() => {
        setPaymentLoading(false);
      });
  };

  useEffect(() => {
    getQuestions();
    getNationality();
  }, []);

  const exclusionsList = [
    t("exclusion_1"),
    t("exclusion_2"),
    t("exclusion_3"),
    t("exclusion_4"),
    t("exclusion_5"),
    t("exclusion_6"),
    t("exclusion_7"),
    t("exclusion_8"),
    t("exclusion_9"),
    t("exclusion_10"),
    t("exclusion_11"),
    t("exclusion_12"),
    t("exclusion_13"),
    t("exclusion_14"),
    t("exclusion_15"),
    t("exclusion_16"),
    t("exclusion_17"),
    t("exclusion_18"),
    t("exclusion_19"),
    t("exclusion_20"),
  ];

  return (
    <BaseLayout
      content={
        <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
          <SpaceBetween size="xs">
            <Flashbar items={flashItems} />

            <Container>
              <Box padding="s">
                {!responseLoaded ? (
                  <Spinner />
                ) : (
                  <SpaceBetween size="l">
                    <Header variant="h2">{t("quotation_request")}</Header>

                    <ContentLayout
                      header={
                        <SpaceBetween size="m">
                          <Header
                            variant="h3"
                            description={t("step1_desc")}
                          >
                            {t("step1_title")}
                          </Header>
                        </SpaceBetween>
                      }
                    >
                      <form onSubmit={(e) => e.preventDefault()}>
                        <Form>
                          <SpaceBetween direction="vertical" size="s">
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
                            <FormField
                              stretch={true}
                              label={<span>{t("label_payment_type")} <span style={{color: 'red'}}>*</span></span>}
                            >
                              <Select
                                selectedOption={paymentType}
                                onChange={({ detail }) => {
                                  setPaymentType(detail.selectedOption);
                                  if (detail.selectedOption?.value !== "Corporate") {
                                    setCompanyName("");
                                  }
                                }}
                                options={[
                                  { label: t("payment_individual"), value: "Individual" },
                                  { label: t("payment_corporate"), value: "Corporate" },
                                ]}
                                placeholder={t("placeholder_payment_type")}
                              />
                            </FormField>
                            <FormField stretch={true} label={<span>{t("label_name")} <span style={{color: 'red'}}>*</span></span>}>
                              <Input
                                onChange={({ detail }) => {
                                  setContactName(detail.value);
                                  if (personsData.length) {
                                    updatePersonData(
                                      0,
                                      "name",
                                      detail.value
                                    );
                                  }
                                }}
                                value={contactName}
                                placeholder={t("placeholder_fullname")}
                              />
                            </FormField>
                            <FormField stretch={true} label={<span>{t("label_email")} <span style={{color: 'red'}}>*</span></span>}>
                              <Input
                                onChange={({ detail }) => {
                                  setContactEmail(detail.value);
                                  if (personsData.length) {
                                    updatePersonData(
                                      0,
                                      "contact_email",
                                      detail.value
                                    );
                                  }
                                }}
                                inputMode="email"
                                type="email"
                                value={contactEmail}
                                placeholder={t("placeholder_email")}
                              />
                            </FormField>
                            <FormField stretch={true} label={<span>{t("label_contact_number")} <span style={{color: 'red'}}>*</span></span>}>
                              <Input
                                onChange={({ detail }) => {
                                  setContactNumber(detail.value);
                                  if (personsData.length) {
                                    updatePersonData(
                                      0,
                                      "contact_number",
                                      detail.value
                                    );
                                  }
                                }}
                                value={contactNumber}
                                inputMode="tel"
                                placeholder={t("placeholder_contact")}
                              />
                            </FormField>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: `${paymentType?.value === "Corporate" ? '1fr 352px 1fr' : '352px 1fr'}`, gap: '16px' }}>
                            {paymentType?.value === "Corporate" && (
                              <FormField stretch={true} label={<span>{t("label_company_name")} <span style={{color: 'red'}}>*</span></span>}>
                                <Input
                                  value={companyName}
                                  onChange={({ detail }) => setCompanyName(detail.value)}
                                  placeholder={t("placeholder_company_name")}
                                />
                              </FormField>
                            )}
                            <FormField
                              stretch={true}
                              label={<span>{t("label_coverage_count")} <span style={{color: 'red'}}>*</span></span>}
                            >
                              <Input
                                onChange={({ detail }) => {
                                  const cleaned = detail.value.replace(/\D/g, "");
                                  setContactPersonInsured(cleaned);
                                  handlePersonCountChange(parseInt(cleaned) || 0);
                                }}
                                value={contactPersonInsured}
                                inputMode="numeric"
                                type="text"
                                placeholder={t("placeholder_coverage_count")}
                              />
                            </FormField>
                            <FormField
                              stretch={true}
                              label={<span>{t("label_start_date")} <span style={{color: 'red'}}>*</span></span>}
                              errorText={startDateError}
                            >
                              <DatePicker
                                onChange={({ detail }) => {
                                  const val = detail.value;
                                  setContactStart(val);
                                  if (val) {
                                    const selected = moment(val, ["YYYY-MM-DD", "YYYY/MM/DD"], true);
                                    const today = moment().startOf("day");
                                    const maxDate = moment().startOf("day").add(30, "days");
                                    if (!selected.isValid()) {
                                      setStartDateError("Please enter a valid date in YYYY/MM/DD format.");
                                    } else if (selected.isBefore(today)) {
                                      setStartDateError("Start date cannot be in the past. Please select a date from today onwards.");
                                    } else if (selected.isAfter(maxDate)) {
                                      setStartDateError("Start date must be within the next 30 days.");
                                    } else {
                                      setStartDateError("");
                                    }
                                  } else {
                                    setStartDateError("");
                                  }
                                }}
                                value={contactStart}
                                openCalendarAriaLabel={(selectedDate) =>
                                  t("aria_choose_start_date") +
                                  (selectedDate
                                    ? `${t("aria_selected_date")} ${selectedDate}`
                                    : "")
                                }
                                isDateEnabled={(date) => {
                                  const d = moment(date).startOf("day");
                                  const today = moment().startOf("day");
                                  const maxDate = moment().startOf("day").add(30, "days");
                                  return d.isSameOrAfter(today) && d.isSameOrBefore(maxDate);
                                }}
                                placeholder={t("placeholder_date")}
                              />
                            </FormField>
                            </div>
                          </SpaceBetween>
                        </Form>
                      </form>
                    </ContentLayout>

                    <ContentLayout
                      header={
                        <SpaceBetween size="m">
                          <Header
                            variant="h3"
                            description={t("step2_desc")}
                          >
                            {t("step2_title")}
                          </Header>
                        </SpaceBetween>
                      }
                    >
                      {personsData.length > 0 ? (
                        <form onSubmit={(e) => e.preventDefault()}>
                          <Form>
                            <SpaceBetween direction="vertical" size="l">
                              {personsData.map((person, index) => (
                                // <Box key={person.id} padding="s" background="grey-50" borderRadius="medium">
                                <ExpandableSection
                                  defaultExpanded
                                  key={person.id}
                                  variant="container"
                                  headerText={
                                    <i>{t("person_info", { num: index + 1 })}</i>
                                  }
                                >
                                  <SpaceBetween size="m">
                                    {/* <Header variant="h4">Person {index + 1}</Header> */}
                                    <Grid
                                      gridDefinition={[
                                        { colspan: { default: 12, xxs: 4 } },
                                        { colspan: { default: 12, xxs: 4 } },
                                        { colspan: { default: 12, xxs: 2 } },
                                        { colspan: { default: 12, xxs: 2 } },
                                      ]}
                                    >
                                      <FormField label={<i>{t("label_name")} <span style={{color: 'red'}}>*</span></i>}>
                                        <Input
                                          value={person.name}
                                          onChange={({ detail }) =>
                                            updatePersonData(
                                              index,
                                              "name",
                                              detail.value
                                            )
                                          }
                                          placeholder={t("placeholder_name")}
                                        />
                                      </FormField>
                                      <FormField
                                        label={<i>{t("label_dob")} <span style={{color: 'red'}}>*</span></i>}
                                        errorText={person.age > 74 ? t("error_max_age") : ""}
                                      >
                                        <SpaceBetween
                                          direction="horizontal"
                                          size="m"
                                        >
                                          <DatePicker
                                            onChange={({ detail }) => {
                                              updatePersonData(
                                                index,
                                                "date_of_birth",
                                                detail.value
                                              );
                                              var plan_data = getPlansByDOB(
                                                person.date_of_birth
                                                  ? person.date_of_birth
                                                  : null
                                              );
                                              var age = plan_data.age;
                                              if (person.plan) {
                                                plan_data = plan_data.plans;
                                                updatePersonData(
                                                  index,
                                                  "eligible_plans",
                                                  plan_data
                                                );
                                                updatePersonData(
                                                  index,
                                                  "quoted_price",
                                                  plan_data[person.plan.value]
                                                );
                                              }
                                              updatePersonData(
                                                index,
                                                "age",
                                                age
                                              );
                                            }}
                                            value={person.date_of_birth}
                                            invalid={person.age > 74}
                                            openCalendarAriaLabel={(
                                              selectedDate
                                            ) =>
                                              t("aria_choose_dob") +
                                              (selectedDate
                                                ? `${t("aria_selected_date")} ${selectedDate}`
                                                : "")
                                            }
                                            isDateEnabled={(date) =>
                                              moment() > moment(date)
                                            }
                                            placeholder={t("placeholder_date")}
                                          />
                                          {person.age ? (
                                            <Badge color={person.age > 74 ? "red" : "green"}>
                                              <strong>
                                                {t("label_age")} <i>{person.age}</i>
                                              </strong>
                                            </Badge>
                                          ) : null}
                                        </SpaceBetween>
                                        {/* <Input
                                          value={person.age}
                                          onChange={({ detail }) => updatePersonData(index, 'age', detail.value)}
                                          type="number"
                                          inputMode="numeric"
                                          placeholder="XX"
                                        /> */}
                                      </FormField>
                                      <FormField label={<span>{t("label_occupation")} <span style={{color: 'red'}}>*</span></span>}>
                                        <Select
                                          selectedOption={
                                            person.present_occupation
                                          }
                                          onChange={({ detail }) =>
                                            updatePersonData(
                                              index,
                                              "present_occupation",
                                              detail.selectedOption
                                            )
                                          }
                                          options={filteredOccupation}
                                          placeholder={t("placeholder_occupation")}
                                          filteringType="manual"
                                          filteringText={filteringText}
                                          onLoadItems={handleLoadItems}
                                          filteringClearAriaLabel="clear"
                                        />
                                      </FormField>
                                      <FormField label={<i>{t("label_gender")} <span style={{color: 'red'}}>*</span></i>}>
                                        <Select
                                          selectedOption={person.gender}
                                          onChange={({ detail }) => {
                                            updatePersonData(
                                              index,
                                              "gender",
                                              detail.selectedOption
                                            );
                                          }}
                                          options={genderOptions}
                                          placeholder={t("placeholder_gender")}
                                        />
                                      </FormField>
                                      {/* <FormField label={<i>Present Occupation</i>}>
                                            <Input
                                              value={person.present_occupation}
                                              onChange={({ detail }) => updatePersonData(index, 'present_occupation', detail.value)}
                                              placeholder="Enter occupation"
                                            />
                                          </FormField> */}
                                      {/* <FormField label="Gender">
                                          <Select
                                            selectedOption={person.gender}
                                            onChange={({ detail }) => updatePersonData(index, 'gender', detail.selectedOption)}
                                            options={genderOptions}
                                            placeholder="Select gender"
                                          />
                                        </FormField> */}
                                    </Grid>
                                    <Grid
                                      gridDefinition={[
                                        { colspan: { default: 12, xxs: 4 } },
                                        { colspan: { default: 12, xxs: 4 } },
                                        { colspan: { default: 12, xxs: 4 } },
                                      ]}
                                    >
                                      <FormField label={<i>{t("label_height")} <span style={{color: 'red'}}>*</span></i>}>
                                        <Input
                                          value={person.height}
                                          onChange={({ detail }) => {
                                            const value =
                                              parseInt(detail.value) || 1;
                                            updatePersonData(
                                              index,
                                              "height",
                                              value
                                            );
                                          }}
                                          placeholder={t("placeholder_height")}
                                          inputMode="numeric"
                                          type="number"
                                        />
                                      </FormField>
                                      <FormField label={<i>{t("label_weight")} <span style={{color: 'red'}}>*</span></i>}>
                                        {/* "Weight (in kg)"> */}
                                        <Input
                                          value={person.weight}
                                          onChange={({ detail }) => {
                                            const value =
                                              parseInt(detail.value) || 1;
                                            updatePersonData(
                                              index,
                                              "weight",
                                              value
                                            );
                                          }}
                                          placeholder={t("placeholder_weight")}
                                          inputMode="numeric"
                                          type="number"
                                        />
                                      </FormField>
                                      <FormField
                                        label={
                                          <i>{t("label_gain_loss")}</i>
                                        }
                                      >
                                        {/* "Gain or Loss past year (in kg)"> */}
                                        <Input
                                          value={person.gain_loss_weight}
                                          onChange={({ detail }) => {
                                            const value =
                                              parseInt(detail.value) || 0;
                                            updatePersonData(
                                              index,
                                              "gain_loss_weight",
                                              value
                                            );
                                          }}
                                          placeholder={t("placeholder_gain_loss")}
                                          inputMode="text"
                                          type="number"
                                        />
                                      </FormField>
                                    </Grid>

                                    <Grid
                                      gridDefinition={[
                                        { colspan: { default: 12, xxs: 4 } },
                                        { colspan: { default: 12, xxs: 4 } },
                                        { colspan: { default: 12, xxs: 4 } },
                                      ]}
                                    >
                                      <FormField
                                        label={<i>{t("label_plan")} <span style={{color: 'red'}}>*</span></i>}
                                        info={
                                          person.plan ? (
                                            <SpaceBetween direction="horizontal" size="xs">
                                              <Button
                                                variant="primary"
                                                onClick={handleModalOpen}
                                              >
                                                {t("view_exclusions")}
                                              </Button>
                                              <Button
                                                variant="primary"
                                                onClick={() => {
                                                  const baseUrl = window.location.origin.includes("localhost")
                                                    ? "http://localhost:5099/api"
                                                    : `${window.location.origin}/api`;
                                                  window.open(`${baseUrl}/download-terms-conditions`, '_blank');
                                                }}
                                              >
                                                {t("terms_conditions")}
                                              </Button>
                                            </SpaceBetween>
                                          ) : null
                                        }
                                      >
                                        {/* "Plan"> */}
                                        <Select
                                          selectedOption={person.plan?.value ? (planOptions.find(o => o.value === person.plan.value) || null) : null}
                                          onChange={({ detail }) => {
                                            updatePersonData(
                                              index,
                                              "plan",
                                              detail.selectedOption
                                            );
                                            updatePersonData(
                                              index,
                                              "quoted_price",
                                              person.eligible_plans[
                                                detail.selectedOption.value
                                              ]
                                            );
                                          }}
                                          options={planOptions}
                                          placeholder={t("placeholder_plan")}
                                          disabled={!person.date_of_birth}
                                        />
                                      </FormField>
                                      <FormField
                                        label={<i>{t("label_physician")}</i>}
                                      >
                                        <Input
                                          value={person.personal_physician}
                                          onChange={({ detail }) =>
                                            updatePersonData(
                                              index,
                                              "personal_physician",
                                              detail.value
                                            )
                                          }
                                          placeholder={t("placeholder_physician")}
                                        />
                                      </FormField>
                                      {person.quoted_price ? (
                                        <FormField label={<i>{t("label_quoted_price")}</i>}>
                                          <Badge color="blue">
                                            <strong>
                                              {t("currency_kd")}{" "}
                                              {parseFloat(
                                                person.quoted_price
                                              ).toFixed(3)}
                                            </strong>
                                          </Badge>
                                        </FormField>
                                      ) : null}
                                    </Grid>
                                    <Grid
                                      gridDefinition={[
                                        { colspan: { default: 12, xxs: 2 } },
                                        { colspan: { default: 12, xxs: 2 } },
                                        { colspan: { default: 12, xxs: 2 } },
                                      ]}
                                    >
                                      <FormField label={<i>{t("label_nationality")} <span style={{color: 'red'}}>*</span></i>}>
                                        <Select
                                          selectedOption={person.nationality_id}
                                          onChange={({ detail }) => {
                                            updatePersonData(
                                              index,
                                              "nationality_id",
                                              detail.selectedOption
                                            );
                                          }}
                                          options={nationalityOptions}
                                          placeholder={t("placeholder_nationality")}
                                          filteringType="auto"
                                          statusType={!isNationalityLoaded ? "loading" : "finished"}
                                          loadingText={t("loading_nationalities")}
                                          filteringPlaceholder={t("filter_nationalities")}
                                          filteringAriaLabel="Filter nationalities"
                                        />
                                      </FormField>
                                      <FormField label={<i>{t("label_national_id")} <span style={{color: 'red'}}>*</span></i>}>
                                        <Input
                                          value={person.national_id}
                                          onChange={({ detail }) =>
                                            updatePersonData(
                                              index,
                                              "national_id",
                                              detail.value
                                            )
                                          }
                                          placeholder={t("placeholder_national_id")}
                                        />
                                      </FormField>
                                      <FormField label={<i>{t("label_passport")} <span style={{color: 'red'}}>*</span></i>}>
                                        <Input
                                          value={person.passport_number}
                                          onChange={({ detail }) =>
                                            updatePersonData(
                                              index,
                                              "passport_number",
                                              detail.value
                                            )
                                          }
                                          placeholder={t("placeholder_passport")}
                                        />
                                      </FormField>
                                      <FormField label={<i>{t("label_contact_number")} <span style={{color: 'red'}}>*</span></i>}>
                                        <Input
                                          value={person.contact_number}
                                          onChange={({ detail }) =>
                                            updatePersonData(
                                              index,
                                              "contact_number",
                                              detail.value
                                            )
                                          }
                                          placeholder={t("placeholder_phone")}
                                        />
                                      </FormField>
                                      <FormField label={<i>{t("label_contact_email")} <span style={{color: 'red'}}>*</span></i>}>
                                        <Input
                                          value={person.contact_email}
                                          onChange={({ detail }) =>
                                            updatePersonData(
                                              index,
                                              "contact_email",
                                              detail.value
                                            )
                                          }
                                          placeholder={t("placeholder_email_short")}
                                        />
                                      </FormField>
                                    </Grid>
                                    <Grid
                                      gridDefinition={[
                                        { colspan: { default: 12, xxs: 6 } },
                                        { colspan: { default: 12, xxs: 6 } },
                                      ]}
                                    >
                                      <FormField
                                        label={<i>{t("label_civil_id")}</i>}
                                        description={t("upload_civil_id_desc")}
                                      >
                                        <FileUpload
                                          onChange={({ detail }) => {
                                            updatePersonData(
                                              index,
                                              "civil_id_files",
                                              detail.value
                                            );
                                            const file = detail.value[0];
                                            if (file) {
                                              const formData = new FormData();
                                              formData.append("file", file);
                                              formData.append("doc_type", "civil_id");
                                              API.post("/upload", formData, {
                                                headers: { "Content-Type": "multipart/form-data" },
                                              }).then((res) => {
                                                if (res.data.operation) {
                                                  updatePersonData(
                                                    index,
                                                    "civil_id_file_path",
                                                    res.data.data.file_path
                                                  );
                                                }
                                              }).catch((err) => console.error("Civil ID upload failed:", err));
                                            } else {
                                              updatePersonData(index, "civil_id_file_path", "");
                                            }
                                          }}
                                          value={person.civil_id_files || []}
                                          i18nStrings={{
                                            uploadButtonText: (e) =>
                                              e ? t("upload_choose_files") : t("upload_choose_file"),
                                            dropzoneText: (e) =>
                                              e ? t("upload_drop_files") : t("upload_drop_file"),
                                            removeFileAriaLabel: (e) =>
                                              `${t("upload_remove_file")} ${e + 1}`,
                                            limitShowFewer: t("upload_show_fewer"),
                                            limitShowMore: t("upload_show_more"),
                                            errorIconAriaLabel: t("upload_error"),
                                          }}
                                          accept=".png,.jpg,.jpeg,.pdf"
                                          multiple={false}
                                          showFileLastModified
                                          showFileSize
                                          showFileThumbnail
                                          constraintText={t("upload_constraint")}
                                        />
                                      </FormField>
                                      <FormField
                                        label={<i>{t("label_passport_doc")}</i>}
                                        description={t("upload_passport_desc")}
                                      >
                                        <FileUpload
                                          onChange={({ detail }) => {
                                            updatePersonData(
                                              index,
                                              "passport_files",
                                              detail.value
                                            );
                                            const file = detail.value[0];
                                            if (file) {
                                              const formData = new FormData();
                                              formData.append("file", file);
                                              formData.append("doc_type", "passport");
                                              API.post("/upload", formData, {
                                                headers: { "Content-Type": "multipart/form-data" },
                                              }).then((res) => {
                                                if (res.data.operation) {
                                                  updatePersonData(
                                                    index,
                                                    "passport_file_path",
                                                    res.data.data.file_path
                                                  );
                                                }
                                              }).catch((err) => console.error("Passport upload failed:", err));
                                            } else {
                                              updatePersonData(index, "passport_file_path", "");
                                            }
                                          }}
                                          value={person.passport_files || []}
                                          i18nStrings={{
                                            uploadButtonText: (e) =>
                                              e ? t("upload_choose_files") : t("upload_choose_file"),
                                            dropzoneText: (e) =>
                                              e ? t("upload_drop_files") : t("upload_drop_file"),
                                            removeFileAriaLabel: (e) =>
                                              `${t("upload_remove_file")} ${e + 1}`,
                                            limitShowFewer: t("upload_show_fewer"),
                                            limitShowMore: t("upload_show_more"),
                                            errorIconAriaLabel: t("upload_error"),
                                          }}
                                          accept=".png,.jpg,.jpeg,.pdf"
                                          multiple={false}
                                          showFileLastModified
                                          showFileSize
                                          showFileThumbnail
                                          constraintText={t("upload_constraint")}
                                        />
                                      </FormField>
                                    </Grid>
                                    <Box marginTop="l">
                                      {!isQuestionsLoaded ? (
                                        <Box textAlign="center" padding="l">
                                          <Spinner />
                                        </Box>
                                      ) : (
                                        <>
                                          <QuestionnaireTable
                                            person={person}
                                            personIndex={index}
                                          />
                                          <TextContent>
                                            <small style={{ color: "red" }}>
                                              {t("mandatory_note")}
                                            </small>
                                          </TextContent>
                                        </>
                                      )}
                                    </Box>
                                  </SpaceBetween>
                                  {/* </Box> */}
                                </ExpandableSection>
                              ))}
                            </SpaceBetween>
                          </Form>
                        </form>
                      ) : (
                        <ExpandableSection
                          key={`person.id`}
                          variant="container"
                          headerText={<i>{t("person_info", { num: 1 })}</i>}
                        ></ExpandableSection>
                      )}
                    </ContentLayout>

                    <ContentLayout
                      header={
                        <SpaceBetween size="m">
                          <Header
                            variant="h3"
                            description={t("step4_desc")}
                          >
                            {t("step4_title")}
                          </Header>
                        </SpaceBetween>
                      }
                    >
                      <SpaceBetween size="s">
                        <SpaceBetween size="s">
                          <Checkbox
                            checked={declarations.truthfulness}
                            onChange={({ detail }) =>
                              handleDeclarationChange(
                                "truthfulness",
                                detail.checked
                              )
                            }
                          >
                            {t("decl_truthfulness")}
                          </Checkbox>

                          <Checkbox
                            checked={declarations.quotationAcknowledgment}
                            onChange={({ detail }) =>
                              handleDeclarationChange(
                                "quotationAcknowledgment",
                                detail.checked
                              )
                            }
                          >
                            {t("decl_quotation")}
                          </Checkbox>

                          <Checkbox
                            checked={declarations.medicalDisclosure}
                            onChange={({ detail }) =>
                              handleDeclarationChange(
                                "medicalDisclosure",
                                detail.checked
                              )
                            }
                          >
                            {t("decl_medical")}
                          </Checkbox>

                          <Checkbox
                            checked={declarations.readIncExc}
                            onChange={({ detail }) =>
                              handleDeclarationChange(
                                "readIncExc",
                                detail.checked
                              )
                            }
                          >
                            {t("decl_inclusions")}
                          </Checkbox>
                        </SpaceBetween>
                      </SpaceBetween>
                    </ContentLayout>
                    {underReviewDone ? (
                      <Alert type="success" header="Application Submitted for Review">
                        Your policy application has been received. As one or more health questionnaire
                        questions were answered <strong>Yes</strong>, your policy is currently
                        <strong> under review</strong> by our underwriting team. A confirmation email
                        has been sent to <strong>{contactEmail}</strong>. Our team will get back to you shortly.
                      </Alert>
                    ) : (
                      <Box textAlign="end">
                        <SpaceBetween direction="horizontal" size="xs">
                          {paymentType?.value === "Individual" ? (
                            <Button
                              disabled={!allDeclarationsChecked || !contactEmail || !paymentType || personsData.some(p => p.age > 74) || paymentLoading || underReviewLoading}
                              loading={paymentLoading || underReviewLoading}
                              onClick={() => {
                                const yesAnswers = getYesAnswers();
                                if (yesAnswers.length > 0) {
                                  submitUnderReview(yesAnswers);
                                } else {
                                  initiatePayment();
                                }
                              }}
                              variant="primary"
                            >
                              {t("payment")}
                            </Button>
                          ) : (
                            <Button
                              disabled={!allDeclarationsChecked || !contactEmail || !paymentType || personsData.some(p => p.age > 74) || underReviewLoading}
                              loading={underReviewLoading}
                              onClick={() => {
                                const yesAnswers = getYesAnswers();
                                if (yesAnswers.length > 0) {
                                  submitUnderReview(yesAnswers);
                                } else {
                                  getQuote();
                                  getSchedule();
                                }
                              }}
                              variant="primary"
                            >
                              {t("get_quote")}
                            </Button>
                          )}
                        </SpaceBetween>
                      </Box>
                    )}
                  </SpaceBetween>
                )}
              </Box>

              {/* Debug Information (remove in production) */}
              {false &&
                process.env.NODE_ENV === "development" && ( // Remove false
                  <ExpandableSection headerText="Debug Info">
                    <Box>
                      <pre>
                        {JSON.stringify(
                          {
                            contactName,
                            contactEmail,
                            contactNumber,
                            contactPersonInsured,
                            personsData,
                          },
                          null,
                          2
                        )}
                      </pre>
                    </Box>
                  </ExpandableSection>
                )}
            </Container>
          </SpaceBetween>

          <Modal
            visible={visible}
            onDismiss={handleModalClose}
            header={t("modal_exclusions_title")}
            size="large"
            footer={
              <Box float="right">
                <SpaceBetween direction="horizontal" size="xs">
                  <Button
                    variant="link"
                    onClick={handleModalClose}
                    disabled={!hasReadToEnd}
                  >
                    {t("modal_cancel")}
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleModalClose}
                    disabled={!hasReadToEnd}
                  >
                    {t("modal_i_understand")}
                  </Button>
                </SpaceBetween>
              </Box>
            }
          >
            <SpaceBetween size="m">
              {!hasReadToEnd && (
                <Alert type="info">
                  {t("modal_scroll_exclusions")}
                </Alert>
              )}

              <Container>
                <SpaceBetween size="s">
                  <Header variant="h3">{t("modal_important_notice")}</Header>
                  <TextContent>
                    <p>
                      {t("modal_exclusions_intro")}
                    </p>
                  </TextContent>
                </SpaceBetween>
              </Container>

              <div
                ref={scrollableRef}
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  border: "1px solid #e1e4e8",
                  borderRadius: "8px",
                  padding: "16px",
                }}
              >
                <Container>
                  <SpaceBetween size="s">
                    <Header variant="h3">{t("modal_exclusions_header")}</Header>
                    <TextContent>
                      <ol>
                        {exclusionsList.map((exclusion, index) => (
                          <li
                            key={index}
                            style={{ marginBottom: "12px", lineHeight: "1.5" }}
                          >
                            {exclusion}
                          </li>
                        ))}
                      </ol>
                    </TextContent>
                  </SpaceBetween>
                </Container>
              </div>

              <Container>
                <Box padding={{ top: "s" }}>
                  <TextContent>
                    <p style={{ fontStyle: "italic", color: "#5f6b7a" }}>
                      <strong>{t("note_label")}</strong> {t("modal_exclusions_note")}
                    </p>
                  </TextContent>
                </Box>
              </Container>
            </SpaceBetween>
          </Modal>

          <Modal
            visible={tcVisible}
            onDismiss={handleTcModalClose}
            header={t("modal_tc_title")}
            size="large"
            footer={
              <Box float="right">
                <SpaceBetween direction="horizontal" size="xs">
                  <Button
                    variant="link"
                    onClick={handleTcModalClose}
                    disabled={!tcHasReadToEnd}
                  >
                    {t("modal_cancel")}
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleTcModalClose}
                    disabled={!tcHasReadToEnd}
                  >
                    {t("modal_i_agree")}
                  </Button>
                </SpaceBetween>
              </Box>
            }
          >
            <SpaceBetween size="m">
              {!tcHasReadToEnd && (
                <Alert type="info">
                  {t("modal_scroll_tc")}
                </Alert>
              )}

              <Container>
                <SpaceBetween size="s">
                  <Header variant="h3">{t("modal_general_terms")}</Header>
                  <TextContent>
                    <p>
                      {t("modal_tc_intro")}
                    </p>
                  </TextContent>
                </SpaceBetween>
              </Container>

              <div
                ref={tcScrollableRef}
                onScroll={handleTcScroll}
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  border: "1px solid #e1e4e8",
                  borderRadius: "8px",
                  padding: "16px",
                }}
              >
                <Container>
                  <SpaceBetween size="s">
                    <Header variant="h3">{t("modal_tc_header")}</Header>
                    <TextContent>
                      <ol>
                        {[1,2,3,4,5,6,7,8,9,10].map((n) => (
                          <li key={n} style={{ marginBottom: "12px", lineHeight: "1.5" }}>
                            <strong>{t(`tc_${n}_title`)}</strong> {t(`tc_${n}_text`)}
                          </li>
                        ))}
                      </ol>
                    </TextContent>
                  </SpaceBetween>
                </Container>
              </div>

              <Container>
                <Box padding={{ top: "s" }}>
                  <TextContent>
                    <p style={{ fontStyle: "italic", color: "#5f6b7a" }}>
                      <strong>{t("note_label")}</strong> {t("modal_tc_note")}
                    </p>
                  </TextContent>
                </Box>
              </Container>
            </SpaceBetween>
          </Modal>
        </div>
      }
    />
  );
};

export default QuotationRequest;
